var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:_vm.containerClass || 'button',attrs:{"id":_vm.id}},[_c('div',{staticClass:"footer-button"},[_c('span',{class:_vm.className})]),_c('figcaption',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }